import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Application } from '../enums/application.enums';
import { AuthService } from './auth.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { PlatformService } from '@core/services/platform.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    @Inject(PLATFORM_ID) private platformId,
    private platformService: PlatformService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.platformService.isPrerendered) {
      return true;
    }
    if (isPlatformBrowser(this.platformId)) {
      let token;
      if (
        !state.url.includes(Application.loginPath) ||
        !state.url.includes(Application.Content)
      ) {
        this.authService.setAuthHistory(state.url);
      }
      const checkLogin: { fm_user: string | null } = { fm_user: '' };
      checkLogin.fm_user = this.authService.getUserIndexedDb();
      if (checkLogin.fm_user) {
        token = checkLogin.fm_user;
      }
      if (
        state.url.includes(Application.SEARCH_RESULT_PAGE) &&
        !state.url.includes(Application.DASHBOARD) &&
        !this.authService.isAuthenticated()
      ) {
        return true;
      }
      const isHomePage = state.url === `/${Application.home}` || state.url.startsWith(`/${Application.home}?`) || state.url.startsWith(`/${Application.home}/`);
      if (
        state.url.includes(Application.loginPath) ||
        state.url === Application.promotional ||
        isHomePage
      ) {
        if (this.authService.isAuthenticated()) {
          if (!state.url.includes(Application.loginPath) &&
            environment.whiteLabelConfig
          ) {
            return true;
          }
          this.router.navigate(['/dashboard/posts']);
          return false;
        } else if (this.authService.getIsCreator()) {
          if (state.url.includes('/auth/creators-signup') || state.url.includes('/auth/login')) {
            return true;
          }
          this.router.navigate(['/auth/creators-signup']);
          return false;
        } else if (this.authService.isUnAuthorizedUser()) {
          this.router.navigate(['/content']);
          return false;
        } else {
          return true;
        }
      } else if (token) {
        return true;
      } else {
        this.authService.removeDetails();
        this.router.navigate(['/auth/login']);
        return false;
      }
    } else{
      return false;
    }
  }
}
